import React, { useEffect } from "react";
import CommandeSuivi from "../components/suivreCommande/CommandeSuivi";
import HomeHeader from "../components/homePage/HomeHeader";
import HomeHeader2 from "@/components/homePage/HomeHeader2";
export default function SuiviCommand({ paniernbr, acces }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <HomeHeader2 acces={acces} paniernbr={paniernbr} />
      <CommandeSuivi />
    </>
  );
}
